import http from '../Http';
import { API_BASE_URL } from '../Helper';

export const fetchActivityLogs = (page = 1, perPage = 20, filters = {}) => {
  return http.get(`${API_BASE_URL}fd/v1/activity-logs`, {
    params: { page, per_page: perPage, ...filters },
  });
};

export const fetchAnalyticsSummary = (filters = {}) => {
  return http.get(`${API_BASE_URL}fd/v1/analytics/summary`, {
    params: filters,
  });
};

export const fetchAllUsers = () => {
    return http.get(`${API_BASE_URL}fd/v1/users`);
}

export const fetchApiVolumeByInterval = (interval = 3600, filters = {}) => {
  const params = { interval };
  if (filters.user_id) {
    params.user_id = filters.user_id;
  }
  if (filters.dates && filters.dates.length === 2) {
    params.start_date = filters.dates[0];
    params.end_date = filters.dates[1];
  }
  return http.get(`${API_BASE_URL}fd/v1/analytics/volume-by-interval`, {
    params,
  });
};
